import { useRef } from 'react';

import Settings from '@/components/Settings';
// import GuestBanner from '@/components/GuestBanner';
// import { useCurrentUserIsGuest } from '@/hooks/users';
import { useAppSelector } from '@/state/store';
import { isSmallMobileWidth } from '@/utils/mobile';
import LocalePickerPanel from '@/components/LocalePickerPanel';
import { LOCALE_PICKER_HEIGHT, LOCALE_PICKER_ANIM_DURATION } from '@/components/LocalePickerPanel';

interface FullpageWrapperProps {
    children: React.ReactNode;
    pageHasProfileDrawer?: boolean;
}

export default function FullpageWrapper({ children, pageHasProfileDrawer }: FullpageWrapperProps) {
    const isSettingsMenuShowing = useAppSelector((state) => state.app.isSettingsMenuShowing);
    const isPurchaseInProgress = useAppSelector((state) => state.app.isPurchaseInProgress);
    const isLocalePickerVisible = useAppSelector((state) => state.app.isLocalePickerPanelVisible);
    const container = useRef<HTMLDivElement>(null);
    const shouldBeInert = isSettingsMenuShowing || isPurchaseInProgress;
    // const isGuest = useCurrentUserIsGuest();
    // const shouldShowGuestBanner = isGuest && !IS_DISCORD_ACTIVITY && !process.env.PUBLIC_DISABLE_GUEST_BANNER;
    const shouldShowSettings = !process.env.PUBLIC_DISABLE_SETTINGS;
    const canShowLocalePicker = process.env.PUBLIC_SUPPORT_TRANSLATIONS === 'true';

    const contentHeight =
        canShowLocalePicker && isLocalePickerVisible ? `calc(100% - ${LOCALE_PICKER_HEIGHT}px)` : '100%';
    // Disable content transition on mobiles to prevent performance issues when animating iFrame height
    const contentTransition =
        canShowLocalePicker && !isSmallMobileWidth() ? `height ${LOCALE_PICKER_ANIM_DURATION}ms ease` : undefined;

    return (
        <div>
            <div
                className="absolute top-0 left-0 w-full h-full overflow-hidden"
                style={{
                    touchAction: 'none',
                    height: contentHeight,
                    transition: contentTransition,
                    backgroundColor: 'black',
                }}
                ref={container}
                onScroll={() => {
                    // Stop scroll jumping to items which become focussed off screen
                    container.current.scrollTo(0, 0);
                }}
            >
                {shouldShowSettings && (
                    <Settings visible={isSettingsMenuShowing} displayNameShouldLinkToProfile={pageHasProfileDrawer} />
                )}

                <div className="absolute top-0 left-0 w-full h-full" inert={shouldBeInert ? '' : undefined}>
                    {children}
                </div>
            </div>
            {/* {shouldShowGuestBanner && <GuestBanner />} */}
            {canShowLocalePicker && <LocalePickerPanel />}
        </div>
    );
}
